module.exports = __webpack_public_path__ + "img/logo.6047fe34.png";